// StructuredData Component - JSON-LD Schema.org Markup
// Created: 2025-12-07
// Purpose: Generate and inject JSON-LD structured data for enhanced search results
// Supports: WebSite, Organization, NewsArticle, FAQPage, BreadcrumbList

import { useEffect } from 'react';
import { StructuredDataBase } from './types';

interface StructuredDataProps {
  data: StructuredDataBase[];
}

const StructuredData: React.FC<StructuredDataProps> = ({ data }) => {
  useEffect(() => {
    // Remove existing structured data scripts to prevent duplicates
    const existingScripts = document.querySelectorAll(
      'script[type="application/ld+json"]'
    );
    existingScripts.forEach((script) => {
      if (script.hasAttribute('data-eduexpertai-seo')) {
        script.remove();
      }
    });

    // Helper function to create and append structured data script
    const addStructuredData = (structuredData: StructuredDataBase) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-eduexpertai-seo', 'true');
      script.text = JSON.stringify(structuredData, null, 2);
      document.head.appendChild(script);
    };

    // Add all structured data items
    if (data && data.length > 0) {
      data.forEach((item) => {
        addStructuredData(item);
      });
    }

    // Cleanup on unmount
    return () => {
      const scripts = document.querySelectorAll(
        'script[data-eduexpertai-seo="true"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, [data]);

  return null; // This component only manages head scripts
};

export default StructuredData;
